import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import Masonry from '@mui/lab/Masonry';
import { Box } from '@mui/material';
import React from 'react';

import { useUser } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import ReportLinkItem from '@sophocles/views/reports/components/ReportLinkItem';
import ReportSection from '@sophocles/views/reports/components/ReportSection';

function AdminDashboard(props) {
  const { loading } = props;
  const { permissions } = useUser();

  const canSeeManagement = permissions.isAccounting || permissions.isShipping;
  const canUpgradeFirmware = permissions.canUpgradeFirmware;

  return (
    <AppNav notFullHeight loading={loading} page="admin_home" {...props}>
      <Box sx={{ top: '64px', mx: 2, pb: 3, display: 'flex', flexDirection: 'column', flex: 1 }}>
        <TitleBar title="Admin Dashboard" subTitle={process.env.VERSION} />

        <Masonry columns={{ xl: 3, lg: 3, md: 2, sm: 1, xs: 1 }} spacing={2} sx={{ m: 0 }}>
          <ReportSection icon={<BuildOutlinedIcon />} title="Engineering">
            <ReportLinkItem to="/staff/firmwarematrix" primary="Firmware Matrix" />
            {canUpgradeFirmware && <ReportLinkItem to="/staff/firmware-upgrades" primary="Firmware Upgrades" />}
            <ReportLinkItem to="/staff/queuestatus" primary="Queue Status" />
            <ReportLinkItem to="/staff/tamperissues" primary="Enclosure Issue" />
            <ReportLinkItem to="/staff/activationquery" primary="Activation Query" />
            <ReportLinkItem to="/staff/excessive-alarms/" primary="Excessive Sites" />
            <ReportLinkItem to="/staff/ethernet/" primary="Ethernet" />
          </ReportSection>

          {canSeeManagement && (
            <ReportSection icon={<SupervisorAccountOutlinedIcon />} title="Management">
              <ReportLinkItem to="/staff/systemnotices/" primary="System Notices" />
              <ReportLinkItem to="/staff/issuecategories/" primary="Issue Categories" />
              <ReportLinkItem to="/staff/rmafee/" primary="RMA Fees" />
              <ReportLinkItem to="/staff/warrantyfee/" primary="Warranty Fees" />
              <ReportLinkItem to="/staff/warrantystatus/" primary="Warranty Status" />
            </ReportSection>
          )}
        </Masonry>
      </Box>
    </AppNav>
  );
}

export default AdminDashboard;
